import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "login-content" }
const _hoisted_2 = { class: "login-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "login-alert",
  role: "alert"
}
const _hoisted_4 = { class: "password-field" }
const _hoisted_5 = ["type"]
const _hoisted_6 = ["aria-pressed"]
const _hoisted_7 = { class: "login-forgot" }
const _hoisted_8 = {
  key: 2,
  class: "contact-form login-form login-confirmation"
}
const _hoisted_9 = {
  key: 3,
  class: "contact-form login-form login-confirmation"
}
const _hoisted_10 = {
  key: 4,
  class: "contact-form login-form login-confirmation"
}
const _hoisted_11 = { class: "password-field" }
const _hoisted_12 = ["type"]
const _hoisted_13 = ["aria-pressed"]
const _hoisted_14 = { class: "password-field" }
const _hoisted_15 = ["type"]
const _hoisted_16 = ["aria-pressed"]
const _hoisted_17 = {
  key: 0,
  class: "login-alert",
  role: "alert"
}
const _hoisted_18 = {
  key: 6,
  class: "login-signup"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[37] || (_cache[37] = _createElementVNode("div", {
        class: "contact-bg",
        "aria-hidden": "true"
      }, null, -1)),
      (_ctx.mode === 'login')
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            class: "contact-form login-form",
            ref: "form",
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.loginSubmit && _ctx.loginSubmit(...args)), ["prevent"])),
            name: "form",
            method: "post"
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("img", {
              class: "login-icon-mark",
              src: "images/favicon.png",
              alt: ""
            }, null, -1)),
            _cache[19] || (_cache[19] = _createElementVNode("h1", { class: "login-subtitle" }, "Login to access your account", -1)),
            (_ctx.message)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.message), 1))
              : _createCommentVNode("", true),
            _cache[20] || (_cache[20] = _createElementVNode("input", {
              class: "form-field",
              type: "email",
              name: "username",
              placeholder: "Email *",
              "aria-label": "Email",
              autocomplete: "email",
              required: "",
              autofocus: ""
            }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("input", {
                class: "form-field",
                type: _ctx.showPassword ? 'text' : 'password',
                name: "password",
                placeholder: "Password *",
                "aria-label": "Password",
                autocomplete: "current-password",
                required: ""
              }, null, 8, _hoisted_5),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["password-toggle", { 'is-visible': _ctx.showPassword }]),
                "aria-pressed": _ctx.showPassword,
                "aria-label": "Show password",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
              }, _cache[17] || (_cache[17] = [
                _createStaticVNode("<svg class=\"password-toggle__icon-show\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"12\" cy=\"12\" r=\"3\" stroke=\"currentColor\" stroke-width=\"2\"></circle></svg><svg class=\"password-toggle__icon-hide\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a19.38 19.38 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a19.5 19.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"></line></svg>", 2)
              ]), 10, _hoisted_6)
            ]),
            _createElementVNode("p", _hoisted_7, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.mode = 'reset-password'))
              }, "Forgotten your password?")
            ]),
            _cache[21] || (_cache[21] = _createElementVNode("button", {
              type: "submit",
              class: "form-submit"
            }, "Login", -1))
          ], 544))
        : (_ctx.mode === 'reset-password')
          ? (_openBlock(), _createElementBlock("form", {
              key: 1,
              class: "contact-form login-form",
              ref: "form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPasswordSubmit && _ctx.resetPasswordSubmit(...args)), ["prevent"])),
              name: "form",
              method: "post"
            }, _cache[22] || (_cache[22] = [
              _createStaticVNode("<img class=\"login-icon-mark\" src=\"images/favicon.png\" alt=\"\"><p class=\"login-subtitle\">Reset your password</p><p class=\"login-forgot-desc\">Enter the email address linked to your account and we’ll send you a link to reset your password.</p><input class=\"form-field\" type=\"email\" name=\"username\" placeholder=\"Email *\" aria-label=\"Email\" autocomplete=\"email\" required autofocus><button type=\"submit\" class=\"form-submit\">Send reset link</button>", 5)
            ]), 544))
          : (_ctx.mode === 'reset-password-request-sent')
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[23] || (_cache[23] = _createElementVNode("img", {
                  class: "login-icon-mark",
                  src: "images/favicon.png",
                  alt: ""
                }, null, -1)),
                _cache[24] || (_cache[24] = _createElementVNode("p", { class: "login-subtitle" }, "Check your email", -1)),
                _cache[25] || (_cache[25] = _createElementVNode("p", { class: "login-forgot-desc" }, "If an account exists for that email address, we’ve sent a link to reset your password. Please check your inbox and your spam folder.", -1)),
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  class: "form-submit",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mode = 'login'))
                }, "Back to login")
              ]))
            : (_ctx.mode === 'password-changed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[26] || (_cache[26] = _createElementVNode("p", { class: "login-subtitle" }, "Password successfully changed", -1)),
                  _cache[27] || (_cache[27] = _createElementVNode("p", { class: "login-forgot-desc" }, "Your password has been updated. You can now log in to your account using your new password.", -1)),
                  _createElementVNode("a", {
                    href: "javascript:void(0);",
                    class: "form-submit",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mode = 'login'))
                  }, "Back to login")
                ]))
              : (_ctx.mode === 'reset-password-expired')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _cache[28] || (_cache[28] = _createElementVNode("p", { class: "login-subtitle" }, "This link is no longer valid", -1)),
                    _cache[29] || (_cache[29] = _createElementVNode("p", { class: "login-forgot-desc" }, "Your password reset link is invalid or has expired. Please request a new one.", -1)),
                    _createElementVNode("a", {
                      href: "javascript:void(0);",
                      class: "form-submit",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mode = 'reset-password'))
                    }, "Request a new link")
                  ]))
                : (_ctx.mode === 'reset-password-new-password')
                  ? (_openBlock(), _createElementBlock("form", {
                      key: 5,
                      class: "contact-form login-form",
                      ref: "form",
                      onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.newPasswordSubmit && _ctx.newPasswordSubmit(...args)), ["prevent"])),
                      name: "form",
                      method: "post"
                    }, [
                      _cache[32] || (_cache[32] = _createElementVNode("img", {
                        class: "login-icon-mark",
                        src: "images/favicon.png",
                        alt: ""
                      }, null, -1)),
                      _cache[33] || (_cache[33] = _createElementVNode("p", { class: "login-subtitle" }, "Set a new password", -1)),
                      _cache[34] || (_cache[34] = _createElementVNode("p", { class: "login-forgot-desc" }, "Choose a new password for your account.", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.resetEmail) = $event)),
                        type: "hidden",
                        name: "username"
                      }, null, 512), [
                        [_vModelText, _ctx.resetEmail]
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.resetReference) = $event)),
                        type: "hidden",
                        name: "reference"
                      }, null, 512), [
                        [_vModelText, _ctx.resetReference]
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.resetPassword) = $event)),
                          class: "form-field",
                          type: _ctx.showNewPassword ? 'text' : 'password',
                          name: "password",
                          placeholder: "New password *",
                          "aria-label": "New password",
                          autocomplete: "new-password",
                          required: "",
                          onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.passwordCheck('password')))
                        }, null, 40, _hoisted_12), [
                          [_vModelDynamic, _ctx.resetPassword]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["password-toggle", { 'is-visible': _ctx.showNewPassword }]),
                          "aria-pressed": _ctx.showNewPassword,
                          "aria-label": "Show password",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showNewPassword = !_ctx.showNewPassword))
                        }, _cache[30] || (_cache[30] = [
                          _createStaticVNode("<svg class=\"password-toggle__icon-show\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"12\" cy=\"12\" r=\"3\" stroke=\"currentColor\" stroke-width=\"2\"></circle></svg><svg class=\"password-toggle__icon-hide\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a19.38 19.38 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a19.5 19.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"></line></svg>", 2)
                        ]), 10, _hoisted_13)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.resetPasswordReenter) = $event)),
                          class: "form-field",
                          type: _ctx.showConfirmPassword ? 'text' : 'password',
                          name: "passwordReenter",
                          placeholder: "Confirm new password *",
                          "aria-label": "Confirm new password",
                          autocomplete: "new-password",
                          required: "",
                          onBlur: _cache[13] || (_cache[13] = ($event: any) => (_ctx.passwordCheck('re-enter')))
                        }, null, 40, _hoisted_15), [
                          [_vModelDynamic, _ctx.resetPasswordReenter]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["password-toggle", { 'is-visible': _ctx.showConfirmPassword }]),
                          "aria-pressed": _ctx.showConfirmPassword,
                          "aria-label": "Show password",
                          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showConfirmPassword = !_ctx.showConfirmPassword))
                        }, _cache[31] || (_cache[31] = [
                          _createStaticVNode("<svg class=\"password-toggle__icon-show\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><circle cx=\"12\" cy=\"12\" r=\"3\" stroke=\"currentColor\" stroke-width=\"2\"></circle></svg><svg class=\"password-toggle__icon-hide\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a19.38 19.38 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a19.5 19.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><line x1=\"1\" y1=\"1\" x2=\"23\" y2=\"23\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"></line></svg>", 2)
                        ]), 10, _hoisted_16)
                      ]),
                      (_ctx.passwordError)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.passwordError), 1))
                        : _createCommentVNode("", true),
                      _cache[35] || (_cache[35] = _createElementVNode("button", {
                        type: "submit",
                        class: "form-submit"
                      }, "Reset password", -1))
                    ], 544))
                  : _createCommentVNode("", true),
      (_ctx.mode !== 'login')
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
            _cache[36] || (_cache[36] = _createTextVNode("Remembered your password? ")),
            _createElementVNode("a", {
              href: "javascript:void(0);",
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.mode = 'login'))
            }, "Back to login")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}